// src/api/index.js
import axios from 'axios';

const rest = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:5000', // ajuste se for outra porta
  headers: {
    'Content-Type': 'application/json',
  },
});

rest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default rest;
